<div class="account-container padding">
  <h1 class="left-box">{{ 'auth.myAccount' | transloco }}</h1>

  <!-- Account Details Section -->
  <div class="section">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'auth.accountDetails' | transloco }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="detail-row">
          <span class="label">{{ 'auth.username' | transloco }}</span>
          <span class="value">{{ username }}</span>
        </div>
        <div class="actions">
          <button mat-raised-button color="primary" (click)="changePassword()">
            {{ 'auth.changePassword' | transloco }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Multi Factor Authentication Section -->
  <div class="section">
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'common.labels.multiFactorAuthentication' | transloco }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="actions">
          <button mat-raised-button color="accent"
            (click)="viewAuthenticator()"
            [disabled]="!isTwoFactorEnabled">
            {{ 'auth.viewAuthenticatorSetup' | transloco }}
          </button>
          @if (!isTwoFactorEnabled) {
            <p
              class="note">
              {{ 'auth.contactYourSystemAdministratorToActivate' | transloco }}
            </p>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>